export enum PromoQueries {
  PromoTable = 'promoTable',
  SearchPromoChangeDummy = 'searchPromoChangeDummy',
}
